// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","cards2":"App_cards2__GA2y0"};